import React from 'react';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

function LiabilityAccountLayout({ classes }) {
  return (
    <div className={classes.root}>
      <MetaField attr="ownerClientId" className={classes.alignLeft} />
      <MetaField attr="otherType" />
      <div className={classes.row}>
        <MetaField attr="loanType" />
        <MetaField attr="interestRate" />
      </div>
      <MetaField attr="minimumMonthlyPayment" />
      <MetaField attr="principalInterestAmount" />
      <MetaField attr="maturityDate" />
      <MetaField attr="pmiAmount" />
      <MetaField attr="insuranceAmount" />
      <MetaField attr="taxesAmount" />
      <MetaField attr="creditCardPaymentType" />
      <MetaField attr="steadyMinimumPayment" />
    </div>
  );
}

LiabilityAccountLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles({
  root: {},
  alignLeft: {
    textAlign: 'left',
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
})(LiabilityAccountLayout);
